/***
 * Filter logic for psr sortenfinder
 *
 *
 *
 ***/
const initialState = {
	// available filters
	filters: new Map(),

	// active filters
	activeFilters: {
		discrete: new Map(),
	},
	// main filter keys
	filterKeys: ['category', 'species', 'subspecies'],

	// main filter objects responding to filterKeys
	// user as keys in activeFilters.discrete
	mainFilters: [],

	// whether extended filter dropdown should be open
	extendedFiltersOpen: false,

	// whether filters have been initialized
	filtersInitialized: false
}
// the redux store
let store = null

// references to check if parts of state have changed
let filtersInitialized = false
let activeFilters = null

// storage functionality
const storage = require('./storage')


// set redux store reference and subscribe to state changes
function init(_store) {
	store = _store
	store.subscribe(subscribe)
}


/*******************
 * event subscribers
 *******************/

// subscribe to action dispatches
function subscribe() {
	onFilterChanged()
	onFiltersInitialized()
}

//
function onFiltersInitialized() {
	if(filtersInitialized || !store.getState().filtersInitialized) {
		return
	}
	filtersInitialized = true

	store.dispatch({type: 'filter', data: {filterKey: 'storage', value: storage.get('filter') || {}}})
}

// filter items
function onFilterChanged() {
	const state = store.getState()
	if(!state.filtersInitialized || state.activeFilters === activeFilters) {
		return
	}

	const filteredItems = filterItems(state)
	activeFilters = state.activeFilters
	store.dispatch({type: 'itemsFiltered', data: filteredItems})
}


/***********
 * reducers
 ***********/


/**
 * reducers
 *
 * @param state
 * @param action
 * @returns state
 */

// update state.activeFilters
function filterReducer(state, action) {
	state = textReducer(state, action)
	state = discreteReducer(state, action)
	state = extendedFilterOpenReducer(state, action)
	state.pagination.page = 0

	writeFilterToStorage(state.activeFilters)
	return state
}

// update state.extendedFiltersOpen
function extendedFilterOpenReducer(state, action) {
	let {type, data} = action
	let matches = data.filterKey.match(/(.*)-(\d+)$/)

	if(type === 'filter' && (!matches || !state.filterKeys.includes(matches[1]))) {
		return state
	}

	state.extendedFiltersOpen = [...state.activeFilters.discrete.entries()].some(([key, filter])=> {
		return !state.mainFilters.includes(key)
	})

	return state

}

// update state.activeFilters.text - text search
function textReducer(state, action) {
	let {filterKey, value} = action.data

	if(filterKey !== 'text' && filterKey !== 'storage') {
		return state
	}

	let text = (filterKey === 'text') ? ('' + value).trim() : value.text || ''

	state.activeFilters = {
		...state.activeFilters,
		text: text,
	}

	return state
}

// update state.filters
// update state.items
function initItemsReducer(state, action) {
	const lang = state.lang
	let filters = new Map()

	action.data.map(item => {
		item.filters = new Set()
		let tempFilters = {extended: new Set()}

		item.tags.map(tag => {
			let fullKey, key, index
			try {
				[fullKey, key, index] = tag.tag.match(/(.*)-(\d+)$/)
			} catch(e) {
				return;
			}

			if(!filters.has(key)) {
				filters.set(key, getFilterEntry('', key, key, lang, index))
			}

			let filter = filters.get(key)
			if(!filter.options.has(fullKey)) {
				filter.options.set(fullKey, getFilterEntry(tag.label, key,  fullKey, lang, index))
			}
			let filterEntry = filter.options.get(fullKey)

			item.filters.add(filterEntry)

			if(state.filterKeys.includes(key)) {
				tempFilters[key] = filterEntry
			}
		})

		for(let filter of item.filters) {
			state.filterKeys.map(key => {
				if(tempFilters[key]) {
					tempFilters[key].relations.add(filter)
				}
			})
		}
	});


	let mainFilters = []
	state.filterKeys.map(key => {
		mainFilters.push(filters.get(key))
	})

	state.items = action.data.map(item => reduceItem(state,item))
	state.config.extendedHidden.map(key => filters.delete(key))
	state.filteredItems = state.items
	state.filters = filters
	state.filtersInitialized = true
	state.mainFilters = mainFilters

	return state
}

// update state.activeFilters.discrete - filters with fixed value options
function discreteReducer(state, action) {
	let {filterKey, value} = action.data
	if(filterKey === 'text') {
		return state
	}

	let fullKey, key, index
	if(filterKey === 'storage') {
		(value.discrete || [])
			.sort((a,b) => state.filterKeys.indexOf(a.key) - state.filterKeys.indexOf(b.key))
			.map(filter => setDiscreteFilter(filter.tag, filter.key, state))
	} else {
		let matches = filterKey.match(/(.*)-(\d+)$/)
		if(matches) {
			[fullKey, key, index] = matches
		} else {
			fullKey = value
			key = filterKey
		}
	}

	state = setDiscreteFilter(fullKey, key, state)

	return state
}

function itemsFilteredReducer(state, action) {
	state.filteredItems = action.data
	let availableFilters = new Set()

	state.filteredItems.map(item => {
		for(let filter of item.filters) {
			availableFilters.add(filter)
		}
	})

	for(let [key, value] of state.activeFilters.discrete.entries()) {
		if(!availableFilters.has(value)) {
			state.activeFilters.discrete.delete(key)
		}
	}

	state.activeFilters.discrete = new Map([...state.activeFilters.discrete.entries()])

	return state
}

function resetFilterReducer(state, action) {
	if(action.type !== 'resetFilter') {
		return state
	}
	state.activeFilters = getEmptyFilter()
	state.extendedFiltersOpen = false
	writeFilterToStorage(state.activeFilters)
	return state
}

function extendedFilterToggleReducer(state, action) {
	if(action.type !== 'extendedFilterToggle') {
		return state
	}
	let isOpen = state.extendedFiltersOpen

	// on closing reset extended filters
	if(isOpen) {
		let discreteFilters = state.activeFilters.discrete
		for(let filter of discreteFilters.keys()) {
			if(!state.mainFilters.includes(filter)) {
				discreteFilters.delete(filter)
			}
		}
		state.activeFilters = {
			...state.activeFilters,
			discrete: new Map([...discreteFilters.entries()]),
		}
	}
	state.extendedFiltersOpen = !isOpen
	return state
}

/***********
 * various
 ***********/

function setDiscreteFilter(fullKey, key, state) {
	let filter = state.filters.get(key)
	let option = filter && state.filters.get(key).options.get(fullKey)

	if(filter) {
		let discreteFilters = state.activeFilters.discrete

		// change of category => reset searchword and extended filters
		if(state.mainFilters[0] == filter) {
			state.activeFilters.text = ''
			for (let discreteFilter of discreteFilters.keys()) {
				if(!state.mainFilters.includes(discreteFilter)) {
					discreteFilters.delete(discreteFilter)
				}
			}
		}

		// toggle filter
		if(!option || discreteFilters.get(filter) === option) {
			discreteFilters.delete(filter)
		} else {
			discreteFilters.set(filter, option)
		}

		// move mainfilter hierarchy down
		// unset all filters not found in relations
		state.mainFilters.map((mainFilter, index) => {
			let activeFilter = discreteFilters.get(mainFilter);
			if(activeFilter) {
				if(index){
					let activeParent = state.activeFilters.discrete.get(state.mainFilters[index - 1]);
					if(!activeParent) {
						discreteFilters.delete(mainFilter)
						return
					}
				}

				discreteFilters = new Map([...discreteFilters.entries()]
					.filter(([filter, option]) => activeFilter.relations.has(option)));
			}
		})

		state.activeFilters = {
			...state.activeFilters,
			discrete: new Map([...discreteFilters.entries()]),
		}
	}
	return state
}

function writeFilterToStorage(activeFilters) {
	let storageFilter  = {
		text: activeFilters.text || '',
		discrete: [...activeFilters.discrete.values()].map((filter) => {return {key: filter.key, tag: filter.tag}})
	}

	storage.set('filter', storageFilter)
}

/**
 * create a filter object
 * to be used as both key and value in state.activeFilters.discrete
 *
 * @param labelSet
 * @param key
 * @param tag
 * @param lang
 * @param index
 * @returns {{label: *, tag: string, key: string, options: Map<any, any>, relations: Set<any>, defaultLabel: *, index: number}}
 */
function getFilterEntry(labelSet, key = '', tag = '', lang = 'default', index) {
	return {
		label:  getTranslation (lang, labelSet),
		tag: tag || key,
		key: key,
		options: new Map(),
		relations: new Set(),
		defaultLabel: getTranslation ('default', labelSet),
		index: +index
	}
}


function getTranslation (lang, languageSet) {
	return languageSet ? (languageSet[lang] || languageSet.default) : ''
}

/**
 * reduce a filter item to necessary properties
 *
 * @param state
 * @param item
 * @returns {{filterTags: string[], tags: *, mainTags: *}}
 */
function reduceItem (state, item) {
	let mainTags = 	item.tags.reduce((mainTags, tag) => {
		let matches = tag.tag.match(/(.*)-(\d+)$/)
		if(matches && state.filterKeys.includes(matches[1])) {
			mainTags[matches[1]] = getTranslation(state.lang, tag.label)
		}
		return mainTags

	}, {});

	return {
		...item,
		filterTags: [...item.filters].map(filter => (state.label[filter.key] || '') + ' ' + filter.label),
		tags: item.tags.map(tag => getTranslation(state.lang, tag.label)),
		mainTags: mainTags
	}
}

/**
 * filter items
 *
 * @param state
 * @returns []
 */
function filterItems(state) {
	const {items, activeFilters, filterKeys} = state

	let filteredItems = items.filter((item) => {
		return ![...activeFilters.discrete.values()].some(filter => !item.filters.has(filter))
	})

	if(activeFilters.text && activeFilters.text.length > 2) {
		let words = activeFilters.text.split(/\s+/g)
		let wordPatterns = words.map(word => new RegExp(word, 'ig'))
		filteredItems = filteredItems.filter(searchText.bind(null, wordPatterns, state))
	}
	return filteredItems.sort((a, b) => a.title.localeCompare(b.title))
}

/**
 * search items for keywords
 *
 * @param wordPatterns
 * @param state
 * @param item
 * @returns {*}
 */
function searchText(wordPatterns, state, item) {
	let fields = [item.psrId, item.title, item.subtitle, item.latinName, item.teaser, item.mainTags, item.synonyms, ...item.filterTags]

	// find all words in any field
	return wordPatterns.every(pattern => fields.some(field => pattern.test(field)))

	// find all words in the same field
	return fields.some(field => wordPatterns.every(pattern => pattern.test(field)))
}


function getEmptyFilter () {
	return {
		discrete: new Map(),
		text: ''
	}
}


module.exports = {
	initialState,
	init,
	reducers: {
		'filter': filterReducer,
		'initItems': initItemsReducer,
		'itemsFiltered': itemsFilteredReducer,
		'resetFilter' : resetFilterReducer,
		'extendedFilterToggle' : extendedFilterToggleReducer
	}
}

